// extracted by mini-css-extract-plugin
export default {"mailReadingPaneHeader":"_7C0r","summaryIcon":"DeLnS","customIcon":"dBz32"};